import React from "react";

const Footer = () => {
  return (
    <div className="text-center container mx-auto border-t border-violet-800">
      <p className="py-5">
        <span className="text-violet-900">Copyright &copy; 2023 </span>
        <a href="https://abirtasrif.com" className="text-violet-400">
          Abir Tasrif
        </a>
      </p>
    </div>
  );
};

export default Footer;
